import React from "react";
import DateLabel from "../../../Controls/DateLabel.mjs";
import TextLabel from "../../../Controls/TextLabel.mjs";
import appLib from "../../../libs/appLib.mjs";

const G = window.glob;
const Event = class extends React.Component{
	constructor(props) {
		super(props);
		this.state={}
		this.uid = G.generateUid(this.props.event?.type ?? 'Event');
		this.additionalClassName = this.additionalClassName.bind(this);
		this.description = this.description.bind(this);
		this.icon = this.icon.bind(this);
		this.details = this.details.bind(this);
		this.isInjection = this.isInjection.bind(this);
	}
	additionalClassName() { return ""; }
	description() {
		const e = this.props.event;
		const out=[];
		if ( e.data?.name ) out.push(<b key={"name"}>{ e.data.name }</b>);
		if ( e.data?.desc ) out.push(<span key={"Desc"} className={"Desc"}>{ e.data.desc }</span>);
		return out;
	}
	icon() {
		return <TextLabel value={'eventType-'+ this.props.event.type}/>;
	}
	details() {
		const e = this.props.event;
		const d = e?.data
		if ( ! d ) return false;
		const src = this.props.options.copione.action[e.id];
		const out = [];
		if ( e.failure ) out.push(<h5 className={"failure"} key={"failure"}><i><TextLabel value={"Failure"}/>:</i> <b>{ e.failure }</b></h5>);
		if ( d.name ) out.push(<h4 key={"Name"}>{ d.name }</h4>);
		if ( d.desc ) out.push(<div key={"Description"}>{ d.desc }</div>);
		if ( src?.from ) {
			out.push(
				<div key={"From"}>
					• <TextLabel value={"From"} />: «
					{ ( Array.isArray(src.from) ? src.from : [src.from]).map( f => appLib.nameByRole(f)).join('», «') }»
				</div>
			)
		}
		if ( Array.isArray(src?.to) ) {
			out.push(
				<div key={"To"}>
					• <TextLabel value={"To"} />: «
					{ src.to.map( (t)=>appLib.nameByRole(t) ).join('», «') }»
				</div>
			)
		}
		return out.length ? out : false;
	}
	isInjection() { return (this.props.event.injection || this.props.event.data?.injection); }
	render() {
		const details = this.details();
		const description = this.description();
		const e = this.props.event;
		return (
			<>
				<div
					className={"EventInfo "+( details ? 'wDetails ' : '')+this.additionalClassName()}
					key={'Info'}
					id={this.uid}
					onClick={ (e)=>{
						e.target.closest(':has(div.EventInfo)').classList.toggle('viewDetails');
					}}
				>
					<span key={"Date"} className={"Date"}>
						<DateLabel value={ e.time } />
					</span>
					<span key={"Type"} className={"Type"}>
						{ this.icon() }
					</span>
					{ description ? (
						<span
							key={"Desc"}
							className={"Desc"}
						>
							{ description }
						</span>
					) : '' }
					{ this.isInjection() ? (
						<span
							key={"Injection"}
							className={"Injection"}
							title={"Injection"}
						/>
					) : ''}
				</div>
				{ this.details() ? <div className={"Details"}> { details }</div> : '' }
			</>
		);
	}
}

export default Event;